module.exports = __webpack_public_path__ + "static/assets/21739a7b303ece303b023791813412cb.svg";